import type businessDocumentItemVM from "../../../BusinessDocuments/BusinessDocumentItemSelector/businessDocumentItemVM";
import type { ServerContractWithdrawalItemVM } from "./ServerContractWithdrawalItemVM";

export interface ContractWithdrawalItemViewModel {
  /** Unique client-side identifier used while adding and editing items. */
  id: string;
  documentItem: businessDocumentItemVM | null;
  amount: number | null;
}

export function contractWithdrawalItemViewModelToServerModel(
  item: ContractWithdrawalItemViewModel,
): ServerContractWithdrawalItemVM {
  return {
    // biome-ignore lint/style/noNonNullAssertion: a document item is required before the item form can be saved
    lineNumber: item.documentItem?.lineNumber!,
    // biome-ignore lint/style/noNonNullAssertion: a document item is required before the item form can be saved
    lineCode: item.documentItem?.lineCode!,
    // biome-ignore lint/style/noNonNullAssertion: a document item is required before the item form can be saved
    productName: item.documentItem?.productName!,
    // biome-ignore lint/style/noNonNullAssertion: a document item is required before the item form can be saved
    catalogNumber: item.documentItem?.catalogNumber!,
    amount: item.amount,
  };
}
